import { render, staticRenderFns } from "./LaundryQcResolve.vue?vue&type=template&id=0989c5f8&scoped=true"
import script from "./LaundryQcResolve.vue?vue&type=script&lang=js"
export * from "./LaundryQcResolve.vue?vue&type=script&lang=js"
import style0 from "./LaundryQcResolve.vue?vue&type=style&index=0&id=0989c5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989c5f8",
  null
  
)

export default component.exports